import { combineReducers } from "redux";

// Authentication & User Management
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AccountReducer from "./auth/register/reducer";
import useReducer from "./users/reducer";
import usersTypeReducer from "./userstypes/reducer";
import PermissionReducer from "./permissions/reducer";
import moduleReducer from "./modules/reducer";

// Layout & General
import LayoutReducer from "./layouts/reducer";

// Master Data
import CategoryReducer from "./category/reducer";
import SubCategoryReducer from "./sub-category/reducer";
import HSNCodeReducer from "./hsn-code/reducer";
import UnitReducer from "./unit/reducer";
import GST from "./gst/reducer";
import ItemReducer from "./item/reducer";
import organisationReducer from "./organisations/reducer";
import departmentReducer from "./department/reducer";
import teamReducer from "./team/reducer";
import warehouseReducer from "./warehosue/reducer";
import configWarehouseReducer from "./warehosue/config.warehosue.reducer";
import supplierReducer from "./suppliers/reducer";
import SupplierMasterReducer from './Master/Supplier/reducer';
import WarehouseMasterReducer from "./Master/Warehouse/reducer";  

// Business Logic - Customer & Labour
import customerReducer from "./Customer/reducer";
import labourReducer from "./Labour/reducer";

// Warehouse - Warehouse Overview
import InStockReducer from './Warehouse/ProjectWarehouse/InStock/reducer';
import DailyLogReducer from "./Warehouse/ProjectWarehouse/DailyLog/reducer";
import DailyLogViewDetailsReducer from './Warehouse/ProjectWarehouse/InStock/ViewDetails/reducer';

// Warehouse - Item Inward
import grnReducer from "./Warehouse/ItemInward2/GRN/reducer";
import pendingLabourInwardReducer from "./Warehouse/ItemInward2/PendingLabourInward/reducer";
import pendingSalesOrderReturnReducer from "./Warehouse/ItemInward2/PendingSalesOrderReturn/reducer";
import pendingStockTransferReducer from "./Warehouse/ItemInward2/PendingStockTransfer/reducer";

// Warehouse Dispatch
import WarehouseDispatchReducer from './Warehouse/Dispatch/Dispatch/reducer';
import IssueToLabourReducer from './Warehouse/Dispatch/IssueToLabour/reducer';
import ReadyForDispatchReducer from './Warehouse/Dispatch/ReadyForDispatch/reducer';
import StockTransferReducer from './Warehouse/Dispatch/StockTransfer/reducer';
import PendingSalesOrderReturnReducer from './Warehouse/ItemInward2/PendingSalesOrderReturn/reducer';

// Inventory - Stock Overview
import StockOverviewReducer from "./Inventory/Inventory/Stock_Overview/reducer";
import WarehouseStockSummaryReducer from "./Inventory/Inventory/Warehouse_Stock_Summary/reducer";
import WarehouseWiseStockReducer from "./Inventory/Inventory/Warehouse_Wise_Stock/reducer";
import InventoryStockReducer from './Inventory/Inventory/Stock_Overview/reducer';
// import EnquirySummaryReducer from "./Dashboard/Enquiry_Summary/reducer";
import WareHouseWiseStockReducer from './Inventory/Inventory/Warehouse_Wise_Stock/reducer';
import recordLevelIteamWiseReducer from "./Inventory/ReorderLevel/ItemWise/reducer";

import QuickActionsReducer from "./Dashboard/Quick_Actions/reducer";
import itemRequestReducer from "./Inventory/ItemRequest/reducer";
import inventoryPackingReducer from "./Inventory/Packing/reducer";
import InventoryStockTransferStateReducer from "./Inventory/StockTransferRequest/StockTransferRequestStockAllocationForm/reducer";
import WarehouseWiseReducer from "./Inventory/ReorderLevel/WarehouseWise/reducer";
import { default as stockTransferlogInventoryReducer, default as StockTransferStockAllocationLogReducer } from "./Inventory/StockTransferRequest/StockTransferRequestStockAllocationLog/reducer";
import transferRequestReducer from "./Inventory/TransferRequest/reducer";
import InventoryOrderReducer from "./Inventory/Order/reducer"
import InventoryStockTransferDispatch from "./Inventory/Dispatch/StockTransfer/reducer"
import InventoryDispatchReducer from "./Inventory/Dispatch/Dispatch/reducer";
import DispatchIssueToLabourReducer from "./Inventory/Dispatch/IsuueToLabour/reducer";
import recordLevelWarehouseWiseReducer from './Inventory/ReorderLevel/WarehouseWise/reducer';
import inventoryDispatchReducer from "./Inventory/Dispatch/reducer";

// Inventory - Item Request
import { default as inventoryItemRequestApprovalLogReducer, default as ItemRequestApprovalLogReducer } from "./Inventory/ItemRequest/ApprovalLog/reducer";
import InventoryItemRequestPendingReducer from "./Inventory/ItemRequest/PendingApproval/reducer";
import ItemRequestStockAllocationLogReducer from "./Inventory/ItemRequest/StockAllocationLog/reducer";

// Inventory - Stock Transfer Request
import StockTransferApprovalLogReducer from "./Inventory/StockTransferRequest/StockTransferRequestApprovalLog/reducer";
import StockTransferPendingApprovalReducer from "./Inventory/StockTransferRequest/StockTransferRequestPendingApproval/reducer";

// Order
import enquiryReducer from "./enquiry/reducer";
import siteVisitReducer from './siteVisit/reducer';
import quotationReducer from "./quotation/reducer";
import orderReducer from './Order/reducer';

// Dashboard Reducers
import DispatchSummaryReducer from "./Dashboard/Dispatch_Summary/reducer";
import EnquirySummaryReducer from "./Dashboard/Enquiry_Summary/reducer";
import InventorySummaryReducer from "./Dashboard/Inventory_Summary/reducer";
import OrderFlowTrackerReducer from "./Dashboard/Order_Flow_Tracker/reducer";
import OrderSummaryReducer from "./Dashboard/Order_Summary/reducer";
import QuotationSummaryReducer from "./Dashboard/Quotation_Summary/reducer";
import TopMetricsReducer from "./Dashboard/Top_Metrics/reducer";
import RevenueBreakdownReducer from "./Dashboard/Revenue_Breakdown/reducer";
import RevenueByDeliveryStatusReducer from "./Dashboard/Revenue_By_Delivery_Status/reducer";

const rootReducer = combineReducers({
  // Authentication & User Management
  users: useReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  usersType: usersTypeReducer,
  Permission: PermissionReducer,
  modules: moduleReducer,

  // Layout & General
  Layout: LayoutReducer,

  // Master Data
  Category: CategoryReducer,
  SubCategory: SubCategoryReducer,
  HSNCode: HSNCodeReducer,
  Unit: UnitReducer,
  GST: GST,
  ItemReducer: ItemReducer,
  Organisations: organisationReducer,
  department: departmentReducer,
  teams: teamReducer,
  warehouse: warehouseReducer,
  // Inventory Reducers
  StockOverviewReducer,
  WarehouseStockSummaryReducer,
  WarehouseWiseStockReducer,
  InventorySummaryReducer,
  // EnquirySummaryReducer,
  DispatchSummaryReducer,
  QuickActionsReducer,
  recordLevelIteamWiseReducer:recordLevelIteamWiseReducer,
  WarehouseWiseReducer,
  ItemRequestApprovalLogReducer: ItemRequestApprovalLogReducer,
  transferRequestReducer,
  itemRequestReducer,
  inventoryPackingReducer,
  inventoryDispatchReducer,
  configWarehouse: configWarehouseReducer,
  suppliers: supplierReducer,
  SupplierMasterReducer,
  WarehouseMasterReducer,
  customer: customerReducer,
  labour: labourReducer,



  // Warehouse - Warehouse Overview
  InStock: InStockReducer,
  DailyLog: DailyLogReducer,
  DailyLogViewDetailsReducer,

  // Warehouse - Item Inward
  grn: grnReducer,
  PendingLabourInward: pendingLabourInwardReducer,
  pendingSalesOrderReturn: pendingSalesOrderReturnReducer,
  pendingStockTransfer: pendingStockTransferReducer,

  // Warehouse Dispatch
  ReadyForDispatch: ReadyForDispatchReducer,
  StockTransfer: StockTransferReducer,
  IssueToLabour: IssueToLabourReducer,
  WarehouseDispatchReducer,
  PendingSalesOrderReturnReducer,


  // Inventory - Inventory
  // Inventory - Stock Overview
  InventoryStockReducer: InventoryStockReducer,
  WareHouseWiseStockReducer: WareHouseWiseStockReducer,

  // Inventory - Reorder Level
  recordLevelWarehouseWiseReducer,

  // Inventory - Item Request
  inventoryItemRequestApprovalLog: inventoryItemRequestApprovalLogReducer,
  inventoryItemRequestPending: InventoryItemRequestPendingReducer,
  ItemRequestStockAllocationLogReducer,

  // Inventory - Stock Transfer Request
  StockTransferApprovalLogReducer,
  StockTransferPendingApprovalReducer,
  StockTransferStockAllocationLogReducer,
  stockTransferlogInventory: stockTransferlogInventoryReducer,
  inventoryStockTransfer: InventoryStockTransferStateReducer,

  // Inventory - Dispatch
  InventoryDispatchReducer: InventoryDispatchReducer,
  InventoryStockTransferDispatch: InventoryStockTransferDispatch,
  DispatchIssueToLabourReducer: DispatchIssueToLabourReducer,

  // Inventory - Order & Packing
  InventoryOrderReducer: InventoryOrderReducer,



  // Order
  Enquiry: enquiryReducer,
  siteVisitReducer: siteVisitReducer,
  Quotation: quotationReducer,
  orderReducer: orderReducer,



  // Dashboard Reducers
  EnquirySummaryReducer,
  OrderSummaryReducer,
  OrderFlowTrackerReducer,
  QuotationSummaryReducer,
  TopMetricsReducer,
  RevenueBreakdownReducer,
  RevenueByDeliveryStatusReducer,
});
export default rootReducer;
